"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generalChangeStatusApi = generalChangeStatusApi;
exports.generalForgotPasswordApi = generalForgotPasswordApi;
exports.generalResetPasswordApi = generalResetPasswordApi;
exports.generalResetPasswordCommonApi = generalResetPasswordCommonApi;
exports.generalSavePasswordApi = generalSavePasswordApi;
exports.generalUniqueAccessApi = generalUniqueAccessApi;
exports.generalValidatePasswordApi = generalValidatePasswordApi;
exports.generalValidateTokenApi = generalValidateTokenApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
var _genericFunction = require("../../../../helpers/genericFunction");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * Reset password common
 * @param payload
 * @returns api response
 * @description this function used to reset passworld its credencials.
 */
function generalResetPasswordCommonApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.general.resetPasswordCommon), params);
}

/**
 * Reset password
 * @param payload
 * @returns api response
 * @description this function used to reset passworld its credencials.
 */
function generalResetPasswordApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.general.resetPassword), params);
}

/**
 * Change status
 * @param payload
 * @returns api response
 * @description this function used to change status.
 */
function generalChangeStatusApi(params) {
  return api.updateWithParam("".concat(_app.default.baseUrl + _dashboard.UserService.general.changeStatus), params);
}

/**
 * Forgot password
 * @param payload
 * @returns api response
 * @description this function used to request for forgot password.
 */
function generalForgotPasswordApi(params) {
  var baseUrl = (0, _genericFunction.getPublicApi)();
  return api.create("".concat(baseUrl + _dashboard.UserService.general.forgotPassword), params);
}

/**
 * save password
 * @param payload
 * @returns api response
 * @description this function used to request for save password.
 */
function generalSavePasswordApi(params) {
  var baseUrl = (0, _genericFunction.getPublicApi)();
  return api.update("".concat(baseUrl + _dashboard.UserService.general.savePassword), params);
}

/**
 * Unique access
 * @param payload
 * @returns api response
 * @description this function used to unique password.
 */
function generalUniqueAccessApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.general.uniqueAccess), params);
}

/**
 * Validate password
 * @param payload
 * @returns api response
 * @description this function used to validate password.
 */
function generalValidatePasswordApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.general.validatePassword), params);
}

/** Validate token
 * @param payload
 * @returns api response
 * @description this function used to check validated token.
 */
function generalValidateTokenApi(params) {
  var baseUrl = (0, _genericFunction.getApiGatewayUrl)();
  return api.get("".concat(baseUrl + _dashboard.UserService.general.validateToken), params);
}